<ng-container *ngIf="(this.categories$ | async) && !globalFilter; else filterCategories">
    <div class="category-facets-carousel-container" #container>
        <div *ngIf="shouldShowLeftArrow" class="arrow left" (click)="onLeftClick()">
            <img class="filter__carousel-btn-icon"
                 src="https://fe-cdn.infra.metro-markets.cloud/images/icons/chevron-left-bluegrey.svg" [alt]="'FILTERS.CATEGORIES_FACETS.ARROW_LEFT.ARIA_LABEL' | translate" />
        </div>
        <div *ngIf="shouldShowRightArrow" class="arrow right" (click)="onRightClick()">
            <img class="filter__carousel-btn-icon"
                 src="https://fe-cdn.infra.metro-markets.cloud/images/icons/chevron-right-bluegrey.svg" [alt]="'FILTERS.CATEGORIES_FACETS.ARROW_RIGHT.ARIA_LABEL' | translate"/>
        </div>
        <div class="carousel" #carousel (scroll)="onScrolled()">
            <div class="carousel__inner" #carouselInner>
                <div *ngFor="let category of categoriesList; let i = index"
                     class="facet"
                     (click)="applyCategory(category)">
                    <div class="facet__img-container">
                        <img class="facet__img"
                             [appDefaultImage]="defaultCategoryImage"
                             [alt]="category?.name"
                             [appLazyLoadImage]="getSource(category?.id)"
                             [srcSet]="getSourceSet(category?.id)"/>
                    </div>
                    <div class="facet__text" [ngClass]="{ bold: isCategorySelected(category?.id)  }">
                        <span>{{ category?.name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #filterCategories>
    <div class="filters">
        <div
                *ngFor="let category of categoriesList | slice:0:limitItems; let i = index"
                class="category-facets__attr filters__overlay"
                [ngClass]="{ category_active: isCategorySelected(category?.id) }"
                (click)="applyCategory(category)"
        >
            <span class="category-facets__attr__name"
                  [ngClass]="{ bold: isCategorySelected(category?.id) }">{{ category?.name }}</span>
            <mm-icon *ngIf="isCategorySelected(category?.id)" class="filter-facets__clearicon"
                     name="close_grey"></mm-icon>
        </div>
    </div>
    <a class="category-facets__show-more"
       *ngIf="hasTruncation"
       [mmTestTarget]="isExpanded ? 'category-show-less-button' : 'category-show-more-button'"
       (click)="toggleShowList(limitItems)">
        {{
        isExpanded
            ? ('SHARED.SHOW_LESS.LABEL' | translate)
            : ('FILTERS.CATEGORIES_LIST.LINK.TEXT.SHOW_MORE' | translate)
        }}
    </a>
</ng-template>
